module.exports = __webpack_public_path__ + "static/media/call_icon.fa251546.svg";